import { Tooltip } from '@assembly-js/design-system';
import { Trans } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

import { BackIcon } from 'src/components/icons';
import { PLAN_PAGE } from 'src/constants';
import { useIsStudioWorkspace } from 'src/hooks/useIsStudioWorkspace';
import useNavigate from 'src/hooks/useNavigate';
import { usePlanStatus } from 'src/hooks/usePlanStatusHook';
import { useAppDispatch, useAppSelector } from 'src/hooks/useStore';
import Button from 'src/legacy/components/Button';
import { typography12MediumStyle } from 'src/legacy/components/Text';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { togglePrimarySidebarMobile } from 'src/store/ui/actions';
import { BlackHeadings } from 'src/theme/colors';

const useStyles = makeStyles()(() => ({
  selectPlanButton: {
    color: BlackHeadings,
    textDecoration: 'underline',
    ...typography12MediumStyle,
  },
}));

export const SettingsSidebarBackToggle = () => {
  const { classes } = useStyles();
  const { navigate } = useNavigate();
  const dispatch = useAppDispatch();
  const backToPortalDestinationPath = useAppSelector(
    (state) => state.ui.backToPortalDestinationPath,
  );
  const isPrimarySidebarOpenOnMobile = useAppSelector(
    (state) => state.ui.primarySideBarMobile.isOpen,
  );
  const { isTrialPeriodExpired, isCancelledPlan, isPaidPlan } = usePlanStatus();
  const isStudioWorkspace = useIsStudioWorkspace();

  const handleBackToggleClicked = () => {
    navigate(backToPortalDestinationPath);

    // Mirror the sidebar nav items: collapse the mobile drawer after
    // navigating so it doesn't stay open over the destination page.
    if (isPrimarySidebarOpenOnMobile) {
      dispatch(togglePrimarySidebarMobile({ isOpen: false }));
    }
  };

  // disable back toggle on settings screen
  const disableBackToggle =
    !isStudioWorkspace &&
    (isTrialPeriodExpired || isCancelledPlan) &&
    !isPaidPlan;
  const backToggle = (
    <Button
      disabled={disableBackToggle}
      htmlId="settings-sidebar-back-toggle"
      startIcon={<BackIcon />}
      variant="text"
      color="primary"
      onClick={handleBackToggleClicked}
    >
      <BaseTypography fontType="13Medium">Go back</BaseTypography>
    </Button>
  );

  const goToPlanSettings = () => {
    navigate(PLAN_PAGE.path);
  };

  return disableBackToggle ? (
    <Tooltip
      offset={{ x: 16 }}
      position="bottom"
      content={
        <BaseTypography fontType="12Medium" style={{ color: BlackHeadings }}>
          <Trans
            i18nKey="messages.sidebar_back_disabled"
            components={{
              Button: (
                <Button
                  htmlId="go-to-select-plan-btn"
                  variant="text"
                  onClick={goToPlanSettings}
                  className={classes.selectPlanButton}
                />
              ),
            }}
          />
        </BaseTypography>
      }
    >
      <div>{backToggle}</div>
    </Tooltip>
  ) : (
    backToggle
  );
};
